module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/dental-fc08852102b5749e2a4982ac8e1060ca.svg";